import React from 'react';
import { Dialog } from 'primereact/dialog';
import styled from 'styled-components';
import { Button } from 'primereact/button';

const Container = styled.div`
  text-align: center;
  padding: 2rem;
`;

const IconWrapper = styled.div`
  background: linear-gradient(135deg, #da67f1, #a68efc);
  border-radius: 50%;
  width: 64px;
  height: 64px;
  margin: 0 auto 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 28px;
`;

const Title = styled.h2`
  color: #9b6bf9;
  margin-bottom: 1rem;
`;

const Description = styled.p`
  font-size: 1.25rem;
  color: #333;
  margin-bottom: 2rem;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
`;

interface UserConsentDialogProps {
  visible: boolean;
  onAccept: () => void;
  onReject: () => void;
  description: string;
}

const UserConsentDialog: React.FC<UserConsentDialogProps> = ({
  visible,
  onAccept,
  onReject,
  description
}) => {
  return (
    <Dialog
      visible={visible}
      onHide={onReject}
      closable={false}
      header={null}
      footer={null}
      style={{ width: '450px', borderRadius: '16px', overflow: 'hidden' }}
    >
      <Container>
        <IconWrapper>
          <i className="pi pi-exclamation-circle" />
        </IconWrapper>
        <Title>User Consent</Title>
        <Description>{description}</Description>
        <ButtonGroup>
          <Button
            label="Decline"
            icon="pi pi-times"
            className="p-button-outlined p-button-secondary"
            onClick={onReject}
            style={{
              borderColor: '#f262b4',
              color: '#f262b4',
              fontWeight: 'bold',
              width: '140px',
              justifyContent: 'center',
              borderRadius: '30px'
            }}
          />
          <Button
            label="Continue"
            icon="pi pi-phone"
            onClick={onAccept}
            style={{
              background: 'linear-gradient(135deg, #da67f1, #7f7bfd)',
              border: 'none',
              fontWeight: 'bold',
              color: 'white',
              width: '140px',
              justifyContent: 'center',
              borderRadius: '30px'
            }}
          />
        </ButtonGroup>
      </Container>
    </Dialog>
  );
};

export default UserConsentDialog;
